var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.linesAreLoading)?_c('heat-map',{attrs:{"lines":_vm.lines}}):_vm._e(),_vm._v(" "),_c('b-loading',{attrs:{"active":_vm.linesAreLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }